import React from "react";
import styled from "styled-components";
import { useGlobalContext } from "./context";
import NavBar from "./NavBar";
import Footer from "./Footer";

const SetupForm = () => {
  const { handleChange, handleSubmit, quiz, error } = useGlobalContext();

  return (
    <>
      <NavBar />
      <Main>
        <Card>
          <FormTitle>Create Quiz</FormTitle>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="amount">Number of Questions</Label>
              <Input
                type="number"
                name="amount"
                id="amount"
                value={quiz.amount}
                onChange={handleChange}
                min={1}
                max={50}
              />
            </FormGroup>
            <FormGroup>
              <Label htmlFor="category">Category</Label>
              <Select
                name="category"
                id="category"
                value={quiz.category}
                onChange={handleChange}
              >
                <option value="sports">Sports</option>
                <option value="history">History</option>
                <option value="politics">Politics</option>
              </Select>
            </FormGroup>
            <FormGroup>
              <Label htmlFor="difficulty">Difficulty</Label>
              <Select
                name="difficulty"
                id="difficulty"
                value={quiz.difficulty}
                onChange={handleChange}
              >
                <option value="easy">Easy</option>
                <option value="medium">Medium</option>
                <option value="hard">Hard</option>
              </Select>
            </FormGroup>
            {error && (
              <ErrorMsg>
                Can't generate questions, please try different options
              </ErrorMsg>
            )}
            <SubmitBtn type="submit">Start</SubmitBtn>
          </Form>
        </Card>
      </Main>
      <Footer />
    </>
  );
};

export default SetupForm;

const Main = styled.main`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-app);
  padding: 110px 1.5rem 200px;
  box-sizing: border-box;
`;

const Card = styled.section`
  background: #fff;
  border-radius: 1.5rem;
  box-shadow: 0 8px 32px rgba(30, 60, 114, 0.12);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 400px;
  text-align: center;
`;

const FormTitle = styled.h2`
  font-family: "Montserrat", sans-serif;
  font-size: 2rem;
  color: #1e3c72;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const Label = styled.label`
  font-size: 1rem;
  color: #232526;
  margin-bottom: 0.5rem;
`;

const Input = styled.input`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #bfc9d9;
  font-size: 1rem;
  width: 100%;
  background: #f7fafd;
  transition: border 0.2s;
  box-sizing: border-box;
  &:focus {
    border-color: #1e90ff;
    outline: none;
  }
`;

const Select = styled.select`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid #bfc9d9;
  font-size: 1rem;
  width: 100%;
  background: #f7fafd;
  transition: border 0.2s;
  box-sizing: border-box;
  &:focus {
    border-color: #1e90ff;
    outline: none;
  }
`;

const ErrorMsg = styled.p`
  color: #ff4c60;
  font-size: 1rem;
  margin: 0.5rem 0 0 0;
`;

const SubmitBtn = styled.button`
  background: linear-gradient(90deg, #1e3c72 0%, #2a5298 100%);
  color: #fff;
  border: none;
  border-radius: 2rem;
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  font-family: "Montserrat", sans-serif;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(30, 60, 114, 0.08);
  transition: background 0.2s, transform 0.2s;
  &:hover {
    background: linear-gradient(90deg, #2a5298 0%, #1e3c72 100%);
    transform: scale(1.05);
  }
`;
